module.exports = __webpack_public_path__ + "static/media/cardsExample.4dbcab82.png";